import { fetcher } from '@commenda/utils';
import { BulkMapAccountsParams } from './types';

const bulkMapAccounts = async (
  policyId: string,
  body: BulkMapAccountsParams
) => {
  const res = await fetcher(
    `transfer-pricing/account-mapping/bulk/update`,
    {
      method: 'POST',
      body: { policyId, ...body },
    }
  );

  return res;
};

export default bulkMapAccounts;
